<main
  class="flex min-h-0 min-w-0 flex-1 flex-col overflow-y-auto overflow-x-hidden"
>
  <mw-sidebar-page-layout
    [menuItems]="menuItems()"
    [fixedHeight]="fixedHeight()"
  >
    <router-outlet />
  </mw-sidebar-page-layout>
</main>
